const collectionsSubcollections = {
  chanel: [
    'Launch Assets',
    'Coco Beach',
    'Coco Charms',
    'Winter Buyers',
    'Fall 21',
    'Fall 21 Animation',
    'Winter 21',
    '21K',
    '21N',
    '22C',
    '23C',
    '23A',
    '23S',
    '23M',
    '23K',
    '23N',
    '24C',
    '24P',
    '24S',
    '24A',
    '24M',
    '24N',
    '24K',
    '25C',
    '25P',
    '25S',
    '25M',
    '25A',
    '25B',
    '25K',
    '25N',
    '26C',
    '26P',
    '26S',
    '26M',
    'Spring 22',
    'Spring 22 Buyers',
    'Summer 22',
    'Fall 22',
    'Winter 22',
    'Fall 22 Buyers',
    'Fall 22 Animation',
    'Winter 22 Animation',
    '22N Coco Neige',
    'Spring 23',
    'Summer 23',
    'Summer 23 Animation',
    'Fall 23',
    'Fall 23 Animation',
    'Winter 23',
    'Winter 23 Animation',
    'Spring 24',
    'Spring 24 Animation',
    'Summer 24',
    'Summer 24 Animation',
    'Fall 24',
    'Winter 24',
    'Winter 24 Animation',
    'Spring 25',
    'Spring 25 Animation',
    'Summer 25',
    'Summer 25 Animation',
    'Fall 25',
    'Winter 25',
    'Spring 26',
    'Summer 26',
    'Summer 26 Animation',
  ],
  chanel2: [
    'Launch Assets',
    'Coco Beach',
    'Coco Charms',
    'Winter Buyers',
    'Fall 21',
    'Fall 21 Animation',
    'Winter 21',
    '21K',
    '21N',
    '22C',
    '23C',
    '23A',
    '23S',
    '23M',
    '23K',
    '23N',
    '24C',
    '24P',
    '24S',
    '24A',
    '24M',
    '24N',
    '24K',
    '25C',
    '25P',
    '25S',
    '25M',
    '25A',
    '25B',
    '25K',
    '25N',
    '26C',
    '26P',
    '26S',
    '26M',
    'Spring 22',
    'Spring 22 Buyers',
    'Summer 22',
    'Fall 22',
    'Winter 22',
    'Fall 22 Buyers',
    'Fall 22 Animation',
    'Winter 22 Animation',
    '22N Coco Neige',
    'Spring 23',
    'Summer 23',
    'Summer 23 Animation',
    'Fall 23',
    'Fall 23 Animation',
    'Winter 23',
    'Winter 23 Animation',
    'Spring 24',
    'Spring 24 Animation',
    'Summer 24',
    'Summer 24 Animation',
    'Fall 24',
    'Winter 24',
    'Winter 24 Animation',
    'Spring 25',
    'Spring 25 Animation',
    'Summer 25',
    'Summer 25 Animation',
    'Fall 25',
    'Winter 25',
    'Spring 26',
    'Summer 26',
    'Summer 26 Animation',
  ],
};
export default collectionsSubcollections;
